<template>
  <v-flex>
    <v-card>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Select partner'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-select
            v-model="selectedPartner"
            :items="partnersList"
            item-value="id"
            item-text="name"
            menu-props="auto"
            hide-details
            label="Select partner"
            single-line
            @change="partnerListSelectChange"
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Currency'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-select
            v-model="selectedPaymentCurrency"
            :items="paymentCurrencyList"
            item-value="value"
            item-text="name"
            label="Currency"
            @change="partnerListSelectChange"
          >
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader
            v-text="
              'User deposits for partner (not included in earlier payments)'
            "
          ></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-select
            v-model="selectedPaymentValues"
            :items="paymentValueList"
            item-value="transaction_hash_hex"
            item-text="item_text"
            label="Deposits value"
            multiple
            @change="paymentValueListSelectChange"
          >
            <template v-slot:prepend-item>
              <v-list-tile ripple @click="toggle">
                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ selectAllButtonText }}</v-list-tile-title
                  >
                </v-list-tile-content>
              </v-list-tile>
              <v-divider class="mt-2"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm12>
          <v-text-field
            v-model="description"
            class="ml-3 mr-3"
            label="Description"
            name="description"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Payment value'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          {{ paymentValue }} WEI (
          {{ selectedPartnerInfo ? selectedPartnerInfo.ref_share_pct : 0 }} % =
          {{
            paymentValue
              ? $options.filters.roundMarketsFractionalAccountValue(
                  $options.filters.toETHFormat(paymentValue)
                )
              : 0
          }}
          {{ selectedPaymentCurrency }})
        </v-flex>
        <v-flex xs12 sm6>
          <v-btn dark color="primary" @click="cratePayment">
            Save
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "AddPayment",
  data: function() {
    return {
      partnersList: [],
      selectedPartner: null,
      paymentValueList: [],
      paymentCurrencyList: [
        { value: "BNB", name: "BNB" },
        { value: "ETH", name: "ETH" }
      ],
      selectedPaymentValues: [],
      selectedPaymentCurrency: "BNB",
      selectedInviteId: null,
      paymentValue: 0,
      description: ""
    };
  },
  computed: {
    ...mapGetters({
      darkmode: "settings/darkmode"
    }),
    likesAllPaymentValues() {
      return this.selectedPaymentValues.length === this.paymentValueList.length;
    },
    selectAllButtonText() {
      return this.selectedPaymentValues.length === this.paymentValueList.length
        ? "Unselect all"
        : "Select all";
    },
    selectedPartnerInfo() {
      let result = null;
      if (this.selectedPartner) {
        for (let item of this.partnersList) {
          if (item.id == this.selectedPartner) {
            result = item;
          }
        }
      }
      return result;
    }
  },

  mounted: async function() {
    axios.get("/api/v1/admin/partners").then(res => {
      this.partnersList = res.data;
    });
  },

  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.paymentValueList.length) {
          if (this.likesAllPaymentValues) {
            this.selectedPaymentValues = [];
            this.paymentValueListSelectChange(null);
          } else {
            this.selectedPaymentValues = this.paymentValueList
              .slice()
              .map(a => a.transaction_hash_hex);
            this.paymentValueListSelectChange(this.selectedPaymentValues);
          }
        }
      });
    },
    partnerListSelectChange() {
      this.selectedPaymentValues = [];
      this.paymentValueList = [];
      this.selectedInviteId = this.selectedPartner;
      this.paymentValue = 0;
      var _this = this;
      axios
        .get(
          "/api/v1/admin/partnerPayments/" +
            this.selectedPartner +
            "/" +
            this.selectedPaymentCurrency
        )
        .then(res => {
          this.paymentValueList = res.data.map(function(entry) {
            entry.item_text =
              _this.$options.filters.formatDateTS(entry.ts_utc_secs) +
              "   User id:" +
              entry.user_id +
              "   " +
              _this.$options.filters.toETHFormat(entry.value_wei_str) +
              " (" +
              _this.selectedPaymentCurrency +
              ")";
            return entry;
          });
        });
    },
    async paymentValueListSelectChange(selectedIds) {
      const { data } = await axios.post("/api/v1/admin/calculatePaymentValue", {
        invite_id: this.selectedInviteId,
        deposits_ids: selectedIds,
        currency: this.selectedPaymentCurrency
      });
      this.paymentValue = data.sum != null ? data.sum : 0;
    },
    async cratePayment() {
      if (this.selectedInviteId && this.selectedPaymentValues.length) {
        const { data } = await axios.post("/api/v1/admin/payments/create", {
          invite_id: this.selectedInviteId,
          deposits_ids: this.selectedPaymentValues,
          description: this.description,
          currency: this.selectedPaymentCurrency
        });

        if (data.status) {
          await swal({
            title: "Payments",
            text: "Payment added successfully",
            showCloseButton: true,
            imageUrl: "/img/popup_img_success.png",
            imageHeight: 80,
            imageWidth: 80,
            customClass: this.themeDark
              ? "swal-type-success-dark"
              : "swal-type-success"
          });
          window.location.reload();
        } else {
          await swal({
            title: "Payments",
            text: "Something went wrong! Please try again.",
            showConfirmButton: false,
            showCloseButton: true,
            customClass: this.themeDark
              ? "swal-type-error-dark"
              : "swal-type-error",
            imageUrl: "/img/popup_img_error.png",
            imageHeight: 80,
            imageWidth: 80
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/AddPayment.vue